import { useEffect, useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import "./Clients.scss";
import { format as dateFormat } from "date-fns";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  InputAdornment,
  ListItemText,
  ListSubheader,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import {
  INIT_FILTER_VALUE,
} from "./filters";
import DateFromTo from "../../../widgets/DateFromTo/DateFromTo";
import BanModal from "./BanModal";
import DepositModal from "./DepositModal";
import EditStaffModal from "./EditStaffModal";
import LegalEntityModal from "./LegalEntityModal";
import VisibilityBlocksModal from "./VisibilityBlocksModal";
import { DOMAIN_API_HOST } from "../../../configs/main";
import TelephoneInput from "../../../widgets/TelephoneInput/TelephoneInput";
import SearchIcon from "@mui/icons-material/Search";
import useAdminUser from "../../../data/useAdminUser";
import { ContentCopy, FilterList, Close } from "@mui/icons-material";
import { useSnackbar } from "notistack";
import SortPopup from "../SortPopUp/SortPopup";
import DataTable from "../Table/Datatable";
import { getDomainConfig } from "../../../configs/main";

const PHONE_MASK = "+7 (___) ___-__-__";

const cloneFilters = (filters) => ({
  ...filters,
  date: { ...filters.date },
  deposite: { ...filters.deposite },
  balance: { ...filters.balance },
  decrease: { ...filters.decrease },
  staffArr: [...(filters.staffArr || [])],
});

const isPhoneFilled = (phone) => {
  const digits = String(phone || "").replace(/\D/g, "");
  return digits.length > 1;
};

const formatRangeChip = (range, label) => {
  if (!range?.start && !range?.end) return null;
  if (range.start && range.end) return `${label}: ${range.start}–${range.end}`;
  if (range.start) return `${label}: от ${range.start}`;
  return `${label}: до ${range.end}`;
};

const formatDateChip = (date) => {
  if (!date) return "";
  try {
    return dateFormat(date instanceof Date ? date : new Date(date), "dd.MM.yyyy");
  } catch (_) {
    return "";
  }
};

function Clients() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { role, user: manager } = useAdminUser();
  const [searchParams] = useSearchParams();
  const isManagerRetargeo = role === "MANAGER_RETARGEO";
  const canAccessProgrammatic =
    !isManagerRetargeo ||
    manager?.id === "c6d89f6c-1a31-419f-846b-7b5b12affa39";
  const [filterArr, setFilter] = useState([]);
  const [arrClients, setClients] = useState([]);
  const [arrStaff, setStaff] = useState([]);
  const [current, setCurent] = useState({});
  const [banModal, setBanModal] = useState(false);
  const [staffModal, setStaffModal] = useState(false);
  const [confirmStaff, setConfirmStaff] = useState(false);
  const [balanceModal, setBalanceModal] = useState(false);
  const [confirmBalance, setConfirmBalance] = useState(false);
  const [legalEntityModal, setLegalEntityModal] = useState(false);
  const [legalEntityCurrent, setLegalEntityCurrent] = useState({});
  const [visibilityModal, setVisibilityModal] = useState(false);
  const [visibilityCurrent, setVisibilityCurrent] = useState({});
  const [filtersValue, setValue] = useState(() => {
    const userId = searchParams.get("user_id");
    if (userId) {
      return { ...INIT_FILTER_VALUE, id: userId };
    }
    return INIT_FILTER_VALUE;
  });
  const [filtersModalOpen, setFiltersModalOpen] = useState(false);
  const [draftFilters, setDraftFilters] = useState(INIT_FILTER_VALUE);

  const [brand, setBrand] = useState(getDomainConfig().brand);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingDots, setLoadingDots] = useState("");
  const [showLongLoadingMessage, setShowLongLoadingMessage] = useState(false);
  const abortControllerRef = useRef(null);

  const [logsModalOpen, setLogsModalOpen] = useState(false);
  const [logsPayload, setLogsPayload] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const ITEMS_PER_PAGE = 15;
  const [shouldResetPage, setShouldResetPage] = useState(false);

  // Функция для построения фильтров для api
  const buildApiFilters = () => {
    const filters = {};

    if (filtersValue.id) filters.id = filtersValue.id;
    if (filtersValue.full_name) filters.full_name = filtersValue.full_name;
    if (filtersValue.email) filters.email = filtersValue.email;
    if (filtersValue.phone) filters.phone_number = filtersValue.phone.replace(/[\s()-]/g, "");
    if (filtersValue.type !== "") filters.is_entity = filtersValue.type;
    if (filtersValue.entity_full_name) filters.entity_full_name = filtersValue.entity_full_name;
    if (filtersValue.site) filters.site = filtersValue.site;
    if (filtersValue.inn) filters.inn = filtersValue.inn;
    if (filtersValue.personal_account) filters.personal_account = filtersValue.personal_account;
    if (filtersValue.agency_clickru) filters.agency = "clickru";
    if (filtersValue.staffArr && filtersValue.staffArr.length > 0) {
      // Берем первого менеджера из массива, так как API принимает только один manager_id
      filters.manager_id = filtersValue.staffArr[0];
    }

    // Диапазон дат
    if (filtersValue.date.date_start || filtersValue.date.date_end) {
      filters.created_at = {};
      if (filtersValue.date.date_start) filters.created_at.from = filtersValue.date.date_start;
      if (filtersValue.date.date_end) filters.created_at.to = filtersValue.date.date_end;
    }

    // Диапазон баланса
    if (filtersValue.balance.start || filtersValue.balance.end) {
      filters.balance_score = {};
      if (filtersValue.balance.start) filters.balance_score.from = +filtersValue.balance.start;
      if (filtersValue.balance.end) filters.balance_score.to = +filtersValue.balance.end;
    }

    // Диапазон пополнений
    if (filtersValue.deposite.start || filtersValue.deposite.end) {
      filters.deposits_amount = {};
      if (filtersValue.deposite.start) filters.deposits_amount.from = +filtersValue.deposite.start;
      if (filtersValue.deposite.end) filters.deposits_amount.to = +filtersValue.deposite.end;
    }

    // Диапазон списаний
    if (filtersValue.decrease.start || filtersValue.decrease.end) {
      filters.charges_amount = {};
      if (filtersValue.decrease.start) filters.charges_amount.from = +filtersValue.decrease.start;
      if (filtersValue.decrease.end) filters.charges_amount.to = +filtersValue.decrease.end;
    }

    if (brand) filters.brand = brand;

    // Сортировка
    if (filtersValue.sort) {
      const sortValue = String(filtersValue.sort);
      if (sortValue.startsWith("balance_score")) {
        filters.sort_by_balance = sortValue.includes("asc") ? 1 : -1;
      }
      if (sortValue.startsWith("created_at")) {
        filters.sort_by_created_at = sortValue.includes("asc") ? 1 : -1;
      }
    }

    return filters;
  };

  useEffect(() => {
    async function fetchData() {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }

      abortControllerRef.current = new AbortController();
      const currentController = abortControllerRef.current;

      setIsLoading(true);
      setClients([]);
      try {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append(
          "Authorization",
          "Bearer " + localStorage.getItem("admin_token")
        );

        const apiFilters = buildApiFilters();

        const res = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/users?brand=${brand}&page=${currentPage}&limit=${ITEMS_PER_PAGE}`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(apiFilters),
          signal: currentController.signal,
        });

        if (currentController.signal.aborted) {
          return;
        }

        if (res.ok) {
          const data = await res.json();
          if (!currentController.signal.aborted) {
            if (data.data && Array.isArray(data.data)) {
              setClients(data.data);
              setFilter(data.data);
              setTotalPages(data.total_pages || 1);
            } else {
              setClients(data);
              setFilter(data);
              setTotalPages(Math.ceil(data.length / ITEMS_PER_PAGE));
            }
          }
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error("Ошибка при загрузке данных:", error);
        }
      } finally {
        if (!currentController.signal.aborted) {
          setIsLoading(false);
        }
      }
    }
    fetchData();

    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [brand, currentPage, filtersValue]);

  useEffect(() => {
    setCurrentPage(1);
  }, [brand]);

  useEffect(() => {
    if (isManagerRetargeo && !canAccessProgrammatic && brand !== "retargeo") {
      setBrand("retargeo");
    }
  }, [isManagerRetargeo, canAccessProgrammatic, brand]);

  useEffect(() => {
    if (!isLoading) {
      setLoadingDots("");
      setShowLongLoadingMessage(false);
      return;
    }

    const dotsInterval = setInterval(() => {
      setLoadingDots(prev => {
        if (prev === "...") return "";
        return prev + ".";
      });
    }, 200);

    const messageTimeout = setTimeout(() => {
      setShowLongLoadingMessage(true);
    }, 3000);

    return () => {
      clearInterval(dotsInterval);
      clearTimeout(messageTimeout);
    };
  }, [isLoading]);

  useEffect(() => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      "Bearer " + localStorage.getItem("admin_token")
    );
    fetch(`${DOMAIN_API_HOST}/api/v1/admin/employee`, {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({}),
    }).then((res) => {
      if (res.ok) {
        res.json().then((data) => {
          setStaff(data);
        });
      }
    });
  }, []);

  const handleAccessToken = async (user_id) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      "Bearer " + localStorage.getItem("admin_token")
    )
    const response = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/auth/access-token/${user_id}`, {
      method: "get",
      headers: myHeaders
    })
    const data = await response.json()
    localStorage.setItem("token", data.access_token);
    return window.open("/")
  }

  const forceUpdateGoals = async (user_id) => {
    const confirm = window.confirm("Вы уверены, что хотите принудительно обновить цели ?");
    if (!confirm) return;
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      "Bearer " + localStorage.getItem("admin_token")
    );
    let response;
    try {
      response = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/clients/forced-goals-update?user_id=${user_id}`, {
        method: "POST",
        headers: myHeaders,
      });
    } catch (networkErr) {
      const message = networkErr?.message || "Сетевая ошибка при обновлении целей";
      const payload = { http_status: null, error: message };
      enqueueSnackbar(message, {
        variant: "error",
        autoHideDuration: 5000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
        action: (key) => (
          <Button onClick={() => { setLogsPayload(payload); setLogsModalOpen(true); closeSnackbar(key); }} size="small" color="inherit">Открыть логи</Button>
        ),
      });
      return;
    }

    let data;
    try {
      data = await response.json();
    } catch (_) {
      try {
        const text = await response.text();
        data = { raw: text };
      } catch (e) {
        data = { error: "Не удалось прочитать ответ сервера" };
      }
    }

    const status = response.status;
    const payload = typeof data === "object" && data !== null ? { http_status: status, ...data } : { http_status: status, body: data };

    if (response.ok) {
      const message = data?.summary || "Цели успешно обновлены";
      enqueueSnackbar(message, {
        variant: data.total_counters === data.failed_updates ? "error" : data.failed_updates !== 0 ? "warning" : "success",
        autoHideDuration: 4000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
        action: (key) => (
          <Button onClick={() => { setLogsPayload(payload); setLogsModalOpen(true); closeSnackbar(key); }} size="small" color="inherit">Открыть логи</Button>
        ),
      });
    } else {
      const message = data?.detail || "Ошибка обновления целей";
      enqueueSnackbar(message, {
        variant: "error",
        autoHideDuration: 6000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
        action: (key) => (
          <Button onClick={() => { setLogsPayload(payload); setLogsModalOpen(true); closeSnackbar(key); }} size="small" color="inherit">Открыть логи</Button>
        ),
      });
    }
  };

  const handleOpenBan = (el) => {
    setBanModal(true);
    setCurent(el);
  };
  const handleCloseBan = () => {
    setBanModal(false);
  };

  const handleOpenBalance = (el) => {
    setBalanceModal(true);
    setCurent(el);
  };
  const handleCloseBalance = () => {
    setBalanceModal(false);
    setConfirmBalance(false);
  };
  const handleOpenLegalEntity = (el) => {
    setLegalEntityCurrent(el);
    setLegalEntityModal(true);
  };
  const handleCloseLegalEntity = () => {
    setLegalEntityModal(false);
  };
  const handleOpenStaff = (el) => {
    setStaffModal(true);
    setCurent(el);
  };
  const handleCloseStaff = () => {
    setStaffModal(false);
    setConfirmStaff(false);
  };
  const handleEditBalance = async (balance_id, newSum, type, isGiftCoupon = false) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      "Bearer " + localStorage.getItem("admin_token")
    );
    try {
      const scoreDiff = type === "Пополнение" ? Number(newSum) : -Number(newSum);
      const payload = {
        score_diff: scoreDiff,
      };

      if (isGiftCoupon) {
        payload.is_promotional = true;
      }

      const res = await fetch(
        `${DOMAIN_API_HOST}/api/v1/admin/balances/${balance_id}`,
        {
          method: "PUT",
          headers: myHeaders,
          body: JSON.stringify(payload),
        }
      );

      if (!res.ok) {
        const errorData = await res.json().catch(() => ({
          detail: "Не удалось изменить баланс клиента",
        }));
        throw new Error(errorData.detail || "Не удалось изменить баланс клиента");
      }

      if (type === "Пополнение") {
        setClients((prev) =>
          prev.map((el) => {
            if (el.balance_id === balance_id) {
              return { ...el, balance_score: +el.balance_score + +newSum };
            }
            return el;
          })
        );
        setFilter(
          filterArr.map((el) => {
            if (el.balance_id === balance_id) {
              return { ...el, balance_score: +el.balance_score + +newSum };
            }
            return el;
          })
        );
      } else {
        setClients((prev) =>
          prev.map((el) => {
            if (el.balance_id === balance_id) {
              return { ...el, balance_score: +el.balance_score - +newSum };
            }
            return el;
          })
        );
        setFilter(
          filterArr.map((el) => {
            if (el.balance_id === balance_id) {
              return { ...el, balance_score: +el.balance_score - +newSum };
            }
            return el;
          })
        );
      }
      enqueueSnackbar("Баланс клиента изменен", {
        variant: "success",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
      handleCloseBalance();
      return true;
    } catch (error) {
      enqueueSnackbar(error.message || "Не удалось изменить баланс клиента", {
        variant: "error",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
      return false;
    }
  };

  const handleEditManager = (id, newManager) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      "Bearer " + localStorage.getItem("admin_token")
    );
    fetch(`${DOMAIN_API_HOST}/api/v1/admin/users/${id}`, {
      method: "PUT",
      headers: myHeaders,
      body: JSON.stringify({
        manager_id: newManager,
      }),
    })
      .then((res) => {
        if (res.ok) {
          arrClients.map((el) => {
            if (el.id === id) {
              return { ...el, manager_id: newManager };
            }
            return el;
          });
          setFilter(
            filterArr.map((el) => {
              if (el.id === id) {
                return { ...el, manager_id: newManager };
              }
              return el;
            })
          );
          enqueueSnackbar("Сотрудник привязан", {
            variant: "success",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
          });
        }
      })
      .catch((error) =>
        enqueueSnackbar(error.message, {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        })
      );
    handleCloseStaff();
  };

  const handleConfirmEmail = async (user) => {
    if (!["ADMIN", "SUPERUSER"].includes(role)) {
      enqueueSnackbar("Подтверждать почту могут только администраторы и суперюзеры", {
        variant: "error",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
      return;
    }

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      "Bearer " + localStorage.getItem("admin_token")
    );

    try {
      const res = await fetch(
        `${DOMAIN_API_HOST}/api/v1/admin/users/${user.id}/confirm-email`,
        {
          method: "POST",
          headers: myHeaders,
        }
      );

      const data = await res.json().catch(() => null);

      if (res.ok) {
        setClients((prev) =>
          prev.map((el) =>
            el.id === user.id ? { ...el, is_email_confirmed: true } : el
          )
        );
        setFilter(
          filterArr.map((el) =>
            el.id === user.id ? { ...el, is_email_confirmed: true } : el
          )
        );
        enqueueSnackbar("Почта пользователя подтверждена", {
          variant: "success",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      } else {
        const message =
          (data && (data.detail || data.error || data.message)) ||
          "Ошибка подтверждения почты";
        enqueueSnackbar(message, {
          variant: "error",
          autoHideDuration: 4000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    } catch (error) {
      enqueueSnackbar(error.message || "Ошибка подтверждения почты", {
        variant: "error",
        autoHideDuration: 4000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
    }
  };

  const downloadFile = async () => {
    const myHeaders = new Headers();

    // Используем ту же функцию построения фильтров, что и для основного API
    const data = buildApiFilters();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      "Bearer " + localStorage.getItem("admin_token")
    );
    const response = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/users/download?brand=${brand}`, {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(data),
    });
    if (response.ok) {
      const link = document.createElement("a");
      let filename = response.headers
        ?.get("content-disposition")
        .split("filename=")[1];
      const blob = await response.blob();
      if (filename === null) filename = "Clients.csv";
      link.download = filename;
      link.href = window.URL.createObjectURL(blob);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  useEffect(() => {
    if (shouldResetPage && currentPage !== 1) {
      setCurrentPage(1);
      setShouldResetPage(false);
    } else if (shouldResetPage) {
      setShouldResetPage(false);
    }
  }, [shouldResetPage, currentPage]);

  const handleFilterChange = (key, value) => {
    setValue((prev) => ({ ...prev, [key]: value }));
    setShouldResetPage(true);
  };

  const handleDraftChange = (key, value) => {
    setDraftFilters((prev) => ({ ...prev, [key]: value }));
  };

  const openFiltersModal = () => {
    setDraftFilters(cloneFilters(filtersValue));
    setFiltersModalOpen(true);
  };

  const applyDraftFilters = () => {
    setValue(
      cloneFilters({
        ...draftFilters,
        id: filtersValue.id,
        email: filtersValue.email,
        site: filtersValue.site,
      })
    );
    setShouldResetPage(true);
    setFiltersModalOpen(false);
  };

  const resetDraftFilters = () => {
    setDraftFilters(
      cloneFilters({
        ...INIT_FILTER_VALUE,
        sort: filtersValue.sort,
        id: filtersValue.id,
        email: filtersValue.email,
        site: filtersValue.site,
      })
    );
  };

  const clearAllFilters = () => {
    setValue(
      cloneFilters({
        ...INIT_FILTER_VALUE,
        sort: filtersValue.sort,
        id: filtersValue.id,
        email: filtersValue.email,
        site: filtersValue.site,
      })
    );
    setShouldResetPage(true);
  };

  const sortChange = (item) => {
    setValue((prev) => ({ ...prev, sort: item.type }));
    setShouldResetPage(true);
  };

  const getActiveFilterChips = () => {
    const chips = [];
    const f = filtersValue;

    if (f.personal_account) chips.push({ key: "personal_account", label: `Л/С: ${f.personal_account}` });
    if (f.full_name) chips.push({ key: "full_name", label: `ФИ: ${f.full_name}` });
    if (isPhoneFilled(f.phone)) chips.push({ key: "phone", label: `Телефон: ${f.phone}` });
    if (f.type !== "") {
      chips.push({
        key: "type",
        label: f.type === true || f.type === "true" ? "Юр. лицо" : "Физ. лицо",
      });
    }
    if (f.entity_full_name) chips.push({ key: "entity_full_name", label: `Юр.лицо: ${f.entity_full_name}` });
    if (f.inn) chips.push({ key: "inn", label: `ИНН: ${f.inn}` });

    if (f.date?.date_start || f.date?.date_end) {
      const from = formatDateChip(f.date.date_start);
      const to = formatDateChip(f.date.date_end);
      let dateLabel = "Дата";
      if (from && to) dateLabel = `Дата: ${from}–${to}`;
      else if (from) dateLabel = `Дата: от ${from}`;
      else if (to) dateLabel = `Дата: до ${to}`;
      chips.push({ key: "date", label: dateLabel });
    }

    if (f.staffArr?.length) {
      const names = arrStaff
        .filter((el) => f.staffArr.includes(el.id))
        .map((el) => el.full_name)
        .filter(Boolean);
      chips.push({
        key: "staffArr",
        label: names.length
          ? `Сотрудники: ${names.join(", ")}`
          : `Сотрудники: ${f.staffArr.length}`,
      });
    }

    const balanceLabel = formatRangeChip(f.balance, "Баланс");
    if (balanceLabel) chips.push({ key: "balance", label: balanceLabel });

    const depositeLabel = formatRangeChip(f.deposite, "Пополнения");
    if (depositeLabel) chips.push({ key: "deposite", label: depositeLabel });

    const decreaseLabel = formatRangeChip(f.decrease, "Списания");
    if (decreaseLabel) chips.push({ key: "decrease", label: decreaseLabel });

    if (f.agency_clickru) chips.push({ key: "agency_clickru", label: "Только clickru" });

    return chips;
  };

  const removeActiveFilter = (key) => {
    const defaults = {
      id: "",
      personal_account: "",
      full_name: "",
      email: "",
      phone: "",
      type: "",
      entity_full_name: "",
      inn: "",
      site: "",
      date: { date_start: "", date_end: "" },
      staffArr: [],
      staff: "",
      balance: { start: "", end: "" },
      deposite: { start: "", end: "" },
      decrease: { start: "", end: "" },
      agency_clickru: false,
    };
    if (key in defaults) {
      handleFilterChange(key, defaults[key]);
    }
  };

  const activeFilterChips = getActiveFilterChips();
  const activeFiltersCount = activeFilterChips.length;

  const columns = [
    {
      Header: "Перейти в ЛК",
      accessor: "redirect",
      maxWidth: 400,
      minWidth: 80,
      width: 120,
      isSticky: true,
    },
    {
      Header: "ID клиента",
      accessor: "id",
      maxWidth: 400,
      minWidth: 80,
      width: 130,
    },
    {
      Header: "Ведение клиента",
      accessor: "agency",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: "Л/С",
      accessor: "personal_account",
      maxWidth: 400,
      minWidth: 80,
      width: 120,
    },
    {
      Header: "ФИ клиента",
      accessor: "full_name",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Логин (email)",
      accessor: "email",
      maxWidth: 400,
      minWidth: 80,
      width: 220,
      isSticky: true,
    },
    {
      Header: "Номер телефона",
      accessor: "phone_number",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: "Название юр.лица",
      accessor: "entity_full_name",
      maxWidth: 400,
      minWidth: 80,
      width: 150,
    },
    {
      Header: "Сайт",
      accessor: "site",
      maxWidth: 400,
      minWidth: 80,
      width: 250,
    },
    {
      Header: "ИНН",
      accessor: "inn",
      maxWidth: 400,
      minWidth: 80,
      width: 120,
    },
    {
      Header: "PK",
      accessor: "campaigns_number",
      maxWidth: 400,
      minWidth: 50,
      width: 100,
    },
    {
      Header: "Дата регистр.",
      accessor: "created_at",
      maxWidth: 400,
      minWidth: 80,
      width: 130,
    },
    {
      Header: "Подтв.",
      accessor: "is_email_confirmed",
      maxWidth: 400,
      minWidth: 50,
      width: 50,
    },
    {
      Header: "Баланс",
      accessor: "balance_score",
      maxWidth: 400,
      minWidth: 80,
      width: 118,
    },
    {
      Header: "Сумма п.",
      accessor: "deposits_amount",
      maxWidth: 400,
      minWidth: 80,
      width: 118,
    },
    {
      Header: "Сумма с.",
      accessor: "charges_amount",
      maxWidth: 400,
      minWidth: 80,
      width: 118,
    },
    {
      Header: "Дата посл. спис.",
      accessor: "last_charge_at",
      maxWidth: 400,
      minWidth: 80,
      width: 130,
    },
    {
      Header: "Дата посл. пополн.",
      accessor: "last_deposit_at",
      maxWidth: 400,
      minWidth: 80,
      width: 130,
    },
    {
      Header: "Сотрудник",
      accessor: "manager_id",
      maxWidth: 400,
      minWidth: 80,
      width: 240,
    },
    {
      Header: "Юр. лицо оплаты",
      accessor: "legal_entity_cell",
      maxWidth: 400,
      minWidth: 120,
      width: 260,
    },
    {
      Header: "Обновить цели",
      accessor: "force_update_goals",
      maxWidth: 400,
      minWidth: 80,
      width: 160,
    },
    {
      Header: "Видимость блоков",
      accessor: "cabinet_visibility",
      maxWidth: 400,
      minWidth: 100,
      width: 160,
    },
    {
      Header: "Отчёт",
      accessor: "create_report",
      maxWidth: 400,
      minWidth: 80,
      width: 120,
    },
    {
      Header: "Подтвердить email",
      accessor: "confirm_email",
      maxWidth: 400,
      minWidth: 120,
      width: 160,
    },
    {
      Header: "",
      accessor: "ban",
      maxWidth: 400,
      minWidth: 50,
      width: 50,
    },
  ].filter((column) => {
    if (column.accessor === "legal_entity_cell") {
      return brand === "retargeo" && ["ADMIN", "SUPERUSER"].includes(role);
    }
    if (column.accessor === "cabinet_visibility") {
      return brand === "programmatic" && role === "SUPERUSER";
    }
    if (!isManagerRetargeo) {
      return true;
    }

    return !["force_update_goals", "create_report", "confirm_email", "ban", "cabinet_visibility"].includes(column.accessor);
  });

  const createReport = async (client_id) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      "Bearer " + localStorage.getItem("admin_token")
    );
    const res = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/production-reports/create?client_id=${client_id}`, {
      method: "POST",
      headers: myHeaders
    });
    if (res.ok) {
      const data = await res.json();
      if (data.ok) {
        enqueueSnackbar("Отчёт успешно создан.", {
          variant: "success",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      } else {
        enqueueSnackbar("Отчёт уже был создан ранее.", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    }
  }

  function getTableData() {
    return filterArr.map((el) => {
      return {
        id: (
          <div
            className="td"
            style={{
              display: "flex",
              flexDirection: "column",
              borderRadius: 5,
            }}
          >
            <span style={{ display: "flex" }}>
              {el.id.slice(0, 8)}
              <ContentCopy
                style={{ marginLeft: 5, cursor: "pointer" }}
                onClick={() => {
                  navigator.clipboard.writeText(el.id);
                  enqueueSnackbar("ID пользователя скопирован", {
                    variant: "success",
                    autoHideDuration: 1000,
                    anchorOrigin: { vertical: "top", horizontal: "right" },
                  });
                }}
                className="copyIcon"
                fontSize="small"
              />
            </span>
            {!el.is_active && <span style={{ opacity: "70%" }}>blocked</span>}
          </div>
        ),
        full_name: (
          <div className="td">{el.full_name ? el.full_name : "-"}</div>
        ),
        email: <div className="td">{el.email ? el.email : "-"}</div>,
        phone_number: (
          <div className="td">{el.phone_number ? el.phone_number : "-"}</div>
        ),
        is_entity: (
          <div className="td">
            {el.is_entity === true
              ? "Юр. лицо"
              : el.is_entity === undefined
                ? "-"
                : "Физ. лицо"}
          </div>
        ),
        entity_full_name: (
          <div className="td">
            {el.entity_full_name ? el.entity_full_name : "-"}
          </div>
        ),
        site: (
          <div className="td">
            <span>{el.site ? el.site : "-"}</span>
            {el.site && (
              <ContentCopy
                style={{
                  marginLeft: 5,
                  position: "relative",
                  top: 4,
                  cursor: "pointer",
                }}
                onClick={() => {
                  navigator.clipboard.writeText(el.site);
                  enqueueSnackbar("Сайт пользователя скопирован", {
                    variant: "success",
                    autoHideDuration: 1000,
                    anchorOrigin: { vertical: "top", horizontal: "right" },
                  });
                }}
                className="copyIcon"
                fontSize="small"
              />
            )}
          </div>
        ),
        agency: (
          <div className="td">
            {el.agency ? el.agency : "к/р"}
          </div>
        ),
        legal_entity_cell: (
          <div className="td">
            {el.legal_entity ? (
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span>{el.legal_entity}</span>
                {el.is_agency_payment && (
                  <span style={{ fontSize: 11, opacity: 0.7 }}>агентство</span>
                )}
                {role === "SUPERUSER" && (
                  <svg
                    onClick={() => handleOpenLegalEntity(el)}
                    style={{ cursor: "pointer" }}
                    width="13"
                    height="12"
                    viewBox="0 0 13 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.49968 1.25391C9.051 1.25391 8.60238 1.424 8.26237 1.76416L2.72868 7.29736C2.62369 7.40236 2.54679 7.53293 2.50603 7.67627L1.76433 10.2734C1.74603 10.3377 1.74524 10.4057 1.76204 10.4704C1.77883 10.535 1.8126 10.594 1.85985 10.6413C1.90709 10.6885 1.96611 10.7223 2.03078 10.7391C2.09545 10.7559 2.16344 10.7551 2.22771 10.7368L4.82536 9.99512L4.82585 9.99463C4.96823 9.9537 5.09848 9.87776 5.20378 9.77246L10.737 4.23877C11.4173 3.55849 11.4173 2.44444 10.737 1.76416C10.397 1.424 9.94835 1.25391 9.49968 1.25391ZM9.49968 1.99951C9.75488 1.99951 10.0097 2.09784 10.2062 2.29443H10.2067C10.6004 2.68815 10.6004 3.31478 10.2067 3.7085L9.72185 4.19336L8.30778 2.7793L8.79265 2.29443C8.98914 2.09784 9.24448 1.99951 9.49968 1.99951ZM7.77751 3.30957L9.19157 4.72363L4.67302 9.24219C4.65836 9.25675 4.6398 9.2679 4.61882 9.27393L2.67058 9.83057L3.22722 7.88184V7.88135C3.23295 7.86119 3.24345 7.84314 3.25896 7.82764L7.77751 3.30957Z"
                      fill="black"
                    />
                  </svg>
                )}
              </div>
            ) : (
              role === "SUPERUSER" && (
                <button
                  onClick={() => handleOpenLegalEntity(el)}
                  style={{
                    padding: "5px 10px",
                    fontSize: "12px",
                    fontWeight: "500",
                    borderRadius: 5,
                    background: "#DFE8FF",
                    color: "#3F73F9",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  Указать
                </button>
              )
            )}
          </div>
        ),
        personal_account: (
          <div className="td">
            {el.personal_account
              ? String(el.personal_account).length <= 5
                ? String(el.personal_account).padStart(6, "0")
                : String(el.personal_account)
              : "-"}
          </div>
        ),
        inn: (
          <div className="td">
            {el.inn ? el.inn : "-"}
          </div>
        ),
        campaigns_number: (
          <div className="td">
            {el.campaigns_number ? el.campaigns_number : "-"}
          </div>
        ),
        created_at: (
          <div className="td">
            {dateFormat(Date.parse(el.created_at), "dd/MM/yyyy")}
          </div>
        ),
        is_email_confirmed: (
          <div className="td">{el.is_email_confirmed ? "+" : "-"}</div>
        ),
        balance_score: (
          <div className="td">
            {el.balance_score ? el.balance_score : "-"}
            {["MANAGER", "ADMIN", "SUPERUSER"].some((el) => el === role) && (
              <svg
                onClick={() => handleOpenBalance(el)}
                style={{ marginLeft: 10, cursor: "pointer" }}
                width="13"
                height="12"
                viewBox="0 0 13 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.49968 1.25391C9.051 1.25391 8.60238 1.424 8.26237 1.76416L2.72868 7.29736C2.62369 7.40236 2.54679 7.53293 2.50603 7.67627L1.76433 10.2734C1.74603 10.3377 1.74524 10.4057 1.76204 10.4704C1.77883 10.535 1.8126 10.594 1.85985 10.6413C1.90709 10.6885 1.96611 10.7223 2.03078 10.7391C2.09545 10.7559 2.16344 10.7551 2.22771 10.7368L4.82536 9.99512L4.82585 9.99463C4.96823 9.9537 5.09848 9.87776 5.20378 9.77246L10.737 4.23877C11.4173 3.55849 11.4173 2.44444 10.737 1.76416C10.397 1.424 9.94835 1.25391 9.49968 1.25391ZM9.49968 1.99951C9.75488 1.99951 10.0097 2.09784 10.2062 2.29443H10.2067C10.6004 2.68815 10.6004 3.31478 10.2067 3.7085L9.72185 4.19336L8.30778 2.7793L8.79265 2.29443C8.98914 2.09784 9.24448 1.99951 9.49968 1.99951ZM7.77751 3.30957L9.19157 4.72363L4.67302 9.24219C4.65836 9.25675 4.6398 9.2679 4.61882 9.27393L2.67058 9.83057L3.22722 7.88184V7.88135C3.23295 7.86119 3.24345 7.84314 3.25896 7.82764L7.77751 3.30957Z"
                  fill="black"
                />
              </svg>
            )}
          </div>
        ),
        deposits_amount: (
          <div className="td">
            {el.deposits_amount ? el.deposits_amount : "-"}
          </div>
        ),
        charges_amount: (
          <div className="td">
            {el.charges_amount ? el.charges_amount : "-"}
          </div>
        ),
        last_charge_at: (
          <div className="td">
            {el?.last_charge_at
              ? dateFormat(Date.parse(el.last_charge_at), "dd/MM/yyyy")
              : "-"}
          </div>
        ),
        last_deposit_at: (
          <div className="td">
            {el.last_deposit_at
              ? dateFormat(Date.parse(el.last_deposit_at), "dd/MM/yyyy")
              : "-"}
          </div>
        ),
        manager_id: (
          <div className="td">
            {el.manager_id
              ? arrStaff
                ?.find((emp) => emp.id === el.manager_id)
                ? `${arrStaff.find((emp) => emp.id === el.manager_id)?.first_name || ""} ${arrStaff.find((emp) => emp.id === el.manager_id)?.surname || ""
                }`
                : ""
              : "-"}
            {(role === "SUPERUSER" || (manager?.id === "7e9c3039-dd0d-4c88-975d-a75dc1853d6e" && role === "ADMIN")) && (
              <svg
                onClick={() => handleOpenStaff(el)}
                style={{ marginLeft: 10, cursor: "pointer" }}
                width="13"
                height="12"
                viewBox="0 0 13 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.49968 1.25391C9.051 1.25391 8.60238 1.424 8.26237 1.76416L2.72868 7.29736C2.62369 7.40236 2.54679 7.53293 2.50603 7.67627L1.76433 10.2734C1.74603 10.3377 1.74524 10.4057 1.76204 10.4704C1.77883 10.535 1.8126 10.594 1.85985 10.6413C1.90709 10.6885 1.96611 10.7223 2.03078 10.7391C2.09545 10.7559 2.16344 10.7551 2.22771 10.7368L4.82536 9.99512L4.82585 9.99463C4.96823 9.9537 5.09848 9.87776 5.20378 9.77246L10.737 4.23877C11.4173 3.55849 11.4173 2.44444 10.737 1.76416C10.397 1.424 9.94835 1.25391 9.49968 1.25391ZM9.49968 1.99951C9.75488 1.99951 10.0097 2.09784 10.2062 2.29443H10.2067C10.6004 2.68815 10.6004 3.31478 10.2067 3.7085L9.72185 4.19336L8.30778 2.7793L8.79265 2.29443C8.98914 2.09784 9.24448 1.99951 9.49968 1.99951ZM7.77751 3.30957L9.19157 4.72363L4.67302 9.24219C4.65836 9.25675 4.6398 9.2679 4.61882 9.27393L2.67058 9.83057L3.22722 7.88184V7.88135C3.23295 7.86119 3.24345 7.84314 3.25896 7.82764L7.77751 3.30957Z"
                  fill="black"
                />
              </svg>
            )}
          </div>
        ),
        redirect: <button
          onClick={() => handleAccessToken(el.id)}
          style={{ padding: "5px 10px", fontSize: "12px", fontWeight: "500", borderRadius: 5, background: "#DFE8FF", color: "#3F73F9" }}>
          Перейти
        </button>,
        force_update_goals: (
          <button
            onClick={() => forceUpdateGoals(el.id)}
            style={{ padding: "5px 10px", fontSize: "12px", fontWeight: "500", borderRadius: 5, background: "#DFE8FF", color: "#3F73F9" }}>
            Обновить цели
          </button>
        ),
        cabinet_visibility: (
          <button
            onClick={() => {
              setVisibilityCurrent(el);
              setVisibilityModal(true);
            }}
            style={{ padding: "5px 10px", fontSize: "12px", fontWeight: "500", borderRadius: 5, background: "#DFE8FF", color: "#3F73F9" }}>
            Открыть
          </button>
        ),
        create_report: (
          <button
            onClick={() => createReport(el.id)}
            style={{ padding: "5px 10px", fontSize: "12px", fontWeight: "500", borderRadius: 5, background: "#DFE8FF", color: "#3F73F9" }}>
            Создать
          </button>
        ),
        ban: (
          <div
            className="td ban"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {role === "SUPERUSER" && (
              <svg
                style={{ cursor: "pointer" }}
                onClick={() => handleOpenBan(el)}
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.3327 0.666016L0.666016 11.3327M11.3327 11.3327L0.666016 0.666016L11.3327 11.3327Z"
                  stroke="#42454C"
                  strokeWidth="1.33333"
                  strokeLinecap="round"
                />
              </svg>
            )}
          </div>
        ),
        confirm_email: (
          <button
            onClick={() => handleConfirmEmail(el)}
            disabled={el.is_email_confirmed}
            style={{
              padding: "5px 10px",
              fontSize: "12px",
              fontWeight: "500",
              borderRadius: 5,
              background: el.is_email_confirmed ? "#e0e0e0" : "#DFE8FF",
              color: el.is_email_confirmed ? "#999999" : "#3F73F9",
              cursor: el.is_email_confirmed ? "default" : "pointer",
            }}
          >
            {el.is_email_confirmed ? "Подтвержден" : "Подтвердить"}
          </button>
        ),
      };
    });
  }

  // Обработчик изменения страницы
  const handlePageChange = (direction) => {
    if (direction === "prev" && currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    } else if (direction === "next" && currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };



  const selectSx = {
    height: 36,
    background: "#f3f4f7",
    borderRadius: "8px",
    fontSize: 14,
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
    },
    "&:hover": {
      background: "#eef0f4",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(63, 115, 249, 0.35)",
    },
    "&.Mui-focused": {
      background: "#fff",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#3F73F9",
      borderWidth: "1px",
    },
  };

  const filterSelectMenuProps = {
    disableScrollLock: true,
    disablePortal: true,
    anchorOrigin: { vertical: "bottom", horizontal: "left" },
    transformOrigin: { vertical: "top", horizontal: "left" },
    PaperProps: {
      className: "ClientsFiltersSelectMenu",
    },
    MenuListProps: {
      className: "ClientsFiltersSelectMenu-list",
    },
  };

  const hasDraftDate =
    !!draftFilters.date?.date_start || !!draftFilters.date?.date_end;

  return (
    <div className="Clients">
      <div className="Clients-header">
        <div className="Clients-headerText">
          <h1>Клиенты</h1>
          <p>
            Список и управление клиентами
            {brand === "retargeo" ? " Retargeo" : " Programmatic"}
          </p>
        </div>
      </div>

      <div className="Clients-toolbar">
        <div className="Clients-toolbarLeft">
          <button
            type="button"
            className={
              activeFiltersCount
                ? "Clients-filterBtn is-active"
                : "Clients-filterBtn"
            }
            onClick={openFiltersModal}
          >
            <FilterList fontSize="small" />
            Фильтры
            {activeFiltersCount > 0 && (
              <span className="Clients-filterBadge">{activeFiltersCount}</span>
            )}
          </button>
          {/* <button
            className="Clients-csvBtn"
            onClick={() => downloadFile()}
            type="button"
          >
            Скачать CSV
          </button> */}
          <SortPopup
            sortedBy={true}
            title="Сортировать по"
            items={[
              { name: "дате регистрации", type: "created_at" },
              { name: "балансу", type: "balance_score" },
            ]}
            onChange={sortChange}
          />
        </div>
      </div>

      <div className="Clients-subbar">
        <div className="Clients-brands">
          {canAccessProgrammatic && (
            <button
              type="button"
              className={
                brand === "programmatic"
                  ? "Clients-brandBtn is-active"
                  : "Clients-brandBtn"
              }
              onClick={() => setBrand("programmatic")}
            >
              Programmatic
            </button>
          )}
          <button
            type="button"
            className={
              brand === "retargeo"
                ? "Clients-brandBtn is-active"
                : "Clients-brandBtn"
            }
            onClick={() => setBrand("retargeo")}
          >
            Retargeo
          </button>
        </div>
        <div className="Clients-quickFilters">
          <input
            className="Clients-quickInput"
            value={filtersValue.id}
            onChange={(e) => {
              setValue((prev) => ({ ...prev, id: e.target.value }));
              setShouldResetPage(true);
            }}
            placeholder="ID клиента"
          />
          <input
            className="Clients-quickInput"
            value={filtersValue.email}
            onChange={(e) => {
              setValue((prev) => ({ ...prev, email: e.target.value }));
              setShouldResetPage(true);
            }}
            placeholder="Email"
          />
          <input
            className="Clients-quickInput"
            value={filtersValue.site}
            onChange={(e) => {
              setValue((prev) => ({ ...prev, site: e.target.value }));
              setShouldResetPage(true);
            }}
            placeholder="Сайт"
          />
        </div>
      </div>

      {activeFiltersCount > 0 && (
        <div className="Clients-chips">
          {activeFilterChips.map((chip) => (
            <button
              key={chip.key}
              type="button"
              className="Clients-chip"
              onClick={() => removeActiveFilter(chip.key)}
              title="Сбросить фильтр"
            >
              <span>{chip.label}</span>
              <Close sx={{ fontSize: 14 }} />
            </button>
          ))}
          <button
            type="button"
            className="Clients-chipsClear"
            onClick={clearAllFilters}
          >
            Сбросить все
          </button>
        </div>
      )}

      <div className="Clients-content">
        {isLoading ? (
          <div className="Clients-loading">
            <div>Загружаем таблицу{loadingDots}</div>
            {showLongLoadingMessage && (
              <div className="Clients-loadingHint">Собираем данные...</div>
            )}
          </div>
        ) : (
          <>
            <div className="Clients-tablePanel">
              <div className="Clients-tableScroll">
                <DataTable data={getTableData()} columns={columns} />
              </div>
            </div>
            <div className="Clients-pagination">
              <button
                type="button"
                className="Clients-pageBtn"
                onClick={() => handlePageChange("prev")}
                disabled={currentPage === 1}
              >
                Назад
              </button>
              <span className="Clients-pageInfo">
                {currentPage} / {totalPages}
              </span>
              <button
                type="button"
                className="Clients-pageBtn"
                onClick={() => handlePageChange("next")}
                disabled={currentPage === totalPages}
              >
                Дальше
              </button>
            </div>
          </>
        )}
      </div>

      <Dialog
        open={filtersModalOpen}
        onClose={() => setFiltersModalOpen(false)}
        maxWidth="md"
        fullWidth
        className="ClientsFiltersDialog"
        PaperProps={{ className: "ClientsFiltersDialog-paper" }}
      >
        <DialogTitle className="ClientsFiltersDialog-title">
          Фильтры клиентов
        </DialogTitle>
        <DialogContent className="ClientsFiltersDialog-content" dividers>
          <div className="Clients-filtersGrid">
            <label className="Clients-field">
              <span>Л/С</span>
              <input
                value={draftFilters.personal_account}
                onChange={(e) =>
                  handleDraftChange("personal_account", e.target.value)
                }
                className="Clients-input"
                placeholder="Номер л/с"
              />
            </label>
            <label className="Clients-field">
              <span>ФИ клиента</span>
              <input
                value={draftFilters.full_name}
                onChange={(e) => handleDraftChange("full_name", e.target.value)}
                className="Clients-input"
                placeholder="ФИО"
              />
            </label>
            <label className="Clients-field">
              <span>Название юр.лица</span>
              <input
                value={draftFilters.entity_full_name}
                onChange={(e) =>
                  handleDraftChange("entity_full_name", e.target.value)
                }
                className="Clients-input"
                placeholder="Название юр.лица"
              />
            </label>
            <label className="Clients-field">
              <span>Телефон</span>
              <TelephoneInput
                onChange={(e) => handleDraftChange("phone", e.target.value)}
                className="Clients-input Clients-input--phone"
                mask={PHONE_MASK}
              />
            </label>
            <div className="Clients-field">
              <span>Физ/Юр лицо</span>
              <FormControl fullWidth size="small">
                <Select
                  sx={selectSx}
                  displayEmpty
                  value={
                    draftFilters.type === "" || draftFilters.type === undefined
                      ? ""
                      : String(draftFilters.type)
                  }
                  onChange={(e) => {
                    const v = e.target.value;
                    handleDraftChange(
                      "type",
                      v === "" ? "" : v === "true"
                    );
                  }}
                  MenuProps={filterSelectMenuProps}
                >
                  <MenuItem value="">Все клиенты</MenuItem>
                  <MenuItem value="false">Физ. лицо</MenuItem>
                  <MenuItem value="true">Юр. лицо</MenuItem>
                </Select>
              </FormControl>
            </div>
            <label className="Clients-field">
              <span>ИНН</span>
              <input
                value={draftFilters.inn}
                onChange={(e) => handleDraftChange("inn", e.target.value)}
                className="Clients-input"
                placeholder="ИНН"
              />
            </label>
            <div className="Clients-field Clients-field--wide">
              <span>Дата регистрации</span>
              <div className="Clients-date">
                <DateFromTo
                  key={`draft-date-${filtersModalOpen}-${hasDraftDate}`}
                  withoutStartDate={!hasDraftDate}
                  from={draftFilters.date.date_start || undefined}
                  to={draftFilters.date.date_end || undefined}
                  handleChange={(value) =>
                    handleDraftChange("date", {
                      date_end: value[1] ?? "",
                      date_start: value[0] ?? "",
                    })
                  }
                />
              </div>
            </div>
            <div className="Clients-field Clients-field--wide">
              <span>Сотрудники</span>
              <FormControl fullWidth size="small">
                <Select
                  sx={selectSx}
                  multiple
                  displayEmpty
                  value={draftFilters.staffArr}
                  onChange={(e) => {
                    const value = e.target.value;
                    handleDraftChange(
                      "staffArr",
                      typeof value === "string" ? value.split(",") : value
                    );
                  }}
                  input={<OutlinedInput />}
                  MenuProps={filterSelectMenuProps}
                  renderValue={(selected) => {
                    if (!selected?.length) return "Все сотрудники";
                    return arrStaff
                      .filter((el) => selected.includes(el.id))
                      .map((el) => el.full_name)
                      .join(", ");
                  }}
                >
                  <ListSubheader>
                    <TextField
                      size="small"
                      placeholder="Поиск"
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                      onChange={(e) => handleDraftChange("staff", e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key !== "Escape") e.stopPropagation();
                      }}
                    />
                  </ListSubheader>
                  {arrStaff
                    .filter((staff) => {
                      if (!draftFilters.staff) return true;
                      return staff.full_name
                        ?.toLowerCase()
                        .includes(draftFilters.staff.toLowerCase());
                    })
                    .map((staff) => (
                      <MenuItem key={staff.id} value={staff.id}>
                        <Checkbox
                          checked={draftFilters.staffArr.indexOf(staff.id) > -1}
                        />
                        <ListItemText primary={staff.full_name} />
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </div>
            <div className="Clients-field">
              <span>Баланс</span>
              <div className="Clients-rangeInputs">
                <input
                  value={draftFilters.balance.start}
                  onChange={(e) =>
                    handleDraftChange("balance", {
                      ...draftFilters.balance,
                      start: e.target.value,
                    })
                  }
                  placeholder="от"
                />
                <input
                  value={draftFilters.balance.end}
                  onChange={(e) =>
                    handleDraftChange("balance", {
                      ...draftFilters.balance,
                      end: e.target.value,
                    })
                  }
                  placeholder="до"
                />
              </div>
            </div>
            <div className="Clients-field">
              <span>Сумма пополнений</span>
              <div className="Clients-rangeInputs">
                <input
                  value={draftFilters.deposite.start}
                  onChange={(e) =>
                    handleDraftChange("deposite", {
                      ...draftFilters.deposite,
                      start: e.target.value,
                    })
                  }
                  placeholder="от"
                />
                <input
                  value={draftFilters.deposite.end}
                  onChange={(e) =>
                    handleDraftChange("deposite", {
                      ...draftFilters.deposite,
                      end: e.target.value,
                    })
                  }
                  placeholder="до"
                />
              </div>
            </div>
            <div className="Clients-field">
              <span>Сумма списаний</span>
              <div className="Clients-rangeInputs">
                <input
                  value={draftFilters.decrease.start}
                  onChange={(e) =>
                    handleDraftChange("decrease", {
                      ...draftFilters.decrease,
                      start: e.target.value,
                    })
                  }
                  placeholder="от"
                />
                <input
                  value={draftFilters.decrease.end}
                  onChange={(e) =>
                    handleDraftChange("decrease", {
                      ...draftFilters.decrease,
                      end: e.target.value,
                    })
                  }
                  placeholder="до"
                />
              </div>
            </div>
            <FormControlLabel
              className="Clients-checkbox"
              control={
                <Checkbox
                  size="small"
                  checked={!!draftFilters.agency_clickru}
                  onChange={(e) =>
                    handleDraftChange("agency_clickru", e.target.checked)
                  }
                />
              }
              label="Только clickru"
            />
          </div>
        </DialogContent>
        <DialogActions className="ClientsFiltersDialog-actions">
          <Button onClick={resetDraftFilters} color="inherit">
            Очистить
          </Button>
          <Button onClick={() => setFiltersModalOpen(false)} color="inherit">
            Отмена
          </Button>
          <Button onClick={applyDraftFilters} variant="contained">
            Применить
          </Button>
        </DialogActions>
      </Dialog>

      <BanModal
        BanModal={banModal}
        handleCloseBan={handleCloseBan}
        user={current}
      />
      <DepositModal
        modal={balanceModal}
        handleCloseModal={handleCloseBalance}
        confirm={confirmBalance}
        setConfirm={setConfirmBalance}
        client={current}
        handleEditBalance={handleEditBalance}
        isSuperUser={role === "SUPERUSER"}
      />
      <EditStaffModal
        modal={staffModal}
        handleCloseModal={handleCloseStaff}
        confirm={confirmStaff}
        setConfirm={setConfirmStaff}
        client={current}
        handleEditManager={handleEditManager}
        arrStaff={arrStaff}
      />
      <LegalEntityModal
        open={legalEntityModal}
        client={legalEntityCurrent}
        handleClose={handleCloseLegalEntity}
        onSaved={(id, legal_entity, is_agency_payment) => {
          const patch = (el) =>
            el.id === id ? { ...el, legal_entity, is_agency_payment } : el;
          setClients((prev) => prev.map(patch));
          setFilter((prev) => prev.map(patch));
        }}
      />
      <VisibilityBlocksModal
        open={visibilityModal}
        client={visibilityCurrent}
        handleClose={() => {
          setVisibilityModal(false);
          setVisibilityCurrent({});
        }}
      />
      <Dialog open={logsModalOpen} onClose={() => setLogsModalOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>Логи обновления целей</DialogTitle>
        <DialogContent dividers>
          {logsPayload?.summary && (
            <div style={{ marginBottom: 16, fontWeight: 600 }}>{logsPayload.summary}</div>
          )}
          {Array.isArray(logsPayload?.results) && logsPayload.results.length > 0 && (
            <div style={{ marginBottom: 16 }}>
              {logsPayload.results.map((r, idx) => (
                <div key={idx} style={{ padding: "8px 0", borderBottom: "1px solid #eee" }}>
                  <div><b>Счетчик:</b> {r.counter_name} ({r.counter_id})</div>
                  <div><b>Статус:</b> {r.success ? "успех" : "ошибка"}</div>
                  <div><b>Добавлено целей:</b> {r.goals_count}</div>
                  {!r.success && r.error_message && (
                    <div style={{ color: "#b71c1c" }}><b>Ошибка:</b> {r.error_message}</div>
                  )}
                </div>
              ))}
            </div>
          )}
          <p style={{ margin: 0, fontSize: 14, fontWeight: 600, marginBottom: 10 }}>Подробные логи</p>
          <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", margin: 0, background: "#f5f5f5", padding: 10, borderRadius: 5 }}>
            {JSON.stringify(logsPayload, null, 2)}
          </pre>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setLogsModalOpen(false)}>Закрыть</Button>
          <Button onClick={() => navigator.clipboard.writeText(JSON.stringify(logsPayload, null, 2))}>Скопировать</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default Clients;
